import { render } from "./GooglePayModal.vue?vue&type=template&id=bfdb631a"
import script from "./GooglePayModal.vue?vue&type=script&lang=js"
export * from "./GooglePayModal.vue?vue&type=script&lang=js"

import "./GooglePayModal.vue?vue&type=style&index=0&id=bfdb631a&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__